import React, { useCallback, useEffect, useState } from 'react'

import { getAllTripsForAdmin } from '@/redux/states/admin/trips/getAllTripsForAdmin/getAllTripsForAdmin.slice'
import { GetAllTripsForAdminData } from '@/redux/states/admin/trips/getAllTripsForAdmin/getAllTripsForAdmin.types'
import { GetAllTripsForAdminRequestPayload } from '@/redux/states/admin/trips/getAllTripsForAdmin/getAllTripsForAdmin.types'
import { getTripDetailsForAdmin } from '@/redux/states/admin/trips/getTripDetailsForAdmin/getTripDetailsForAdmin.slice'
import { GetTripDetailsForAdminRequestPayload } from '@/redux/states/admin/trips/getTripDetailsForAdmin/getTripDetailsForAdmin.types'
import { getTripOfferRequestsForAdmin } from '@/redux/states/admin/trips/getTripOfferRequestsForAdmin/getTripOfferRequestsForAdmin.slice'
import { GetTripOfferRequestsForAdminRequestPayload } from '@/redux/states/admin/trips/getTripOfferRequestsForAdmin/getTripOfferRequestsForAdmin.types'
import { getTripPaymentDetailsForAdmin } from '@/redux/states/admin/trips/getTripPaymentDetailsForAdmin/getTripPaymentDetailsForAdmin.slice'
import { GetTripPaymentDetailsForAdminRequestPayload } from '@/redux/states/admin/trips/getTripPaymentDetailsForAdmin/getTripPaymentDetailsForAdmin.types'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'

import Table from '../../../../shared/components/Table/Table.component'

import env from '../../../../networkRequests/apiClient/env.config'
import { RootState } from '../../../../redux/store/store.types'
import { useAppDispatch } from '../../../../shared/hooks/redux.hooks'
import { adminNavigationPaths } from '../../AdminDashboard.dictionary'
import { tripTableColumns } from './Trips.dictionary'
import styles from './Trips.styles'
import { TripsProps } from './Trips.types'

const Trips: React.FC<TripsProps> = (props) => {
  const { searchQuery, demoRouter, setSelectedUser } = props

  const [tripsPage, setTripsPage] = useState(1)
  const [tripsTotalPages, setTripsTotalPages] = useState(1)
  const [tripsTotalRecords, setTripsTotalRecords] = useState(0)
  const [tripsData, setTripsData] = useState<GetAllTripsForAdminData['records']>([])

  const pageSize = env.DEFAULT_PAGE_SIZE
  const dispatch = useAppDispatch()

  const {
    loading: tripsLoading,
    success: tripsSuccess,
    error: tripsError
  } = useSelector((state: RootState) => state.getAllTripsForAdmin)

  useEffect(() => {
    if (tripsSuccess?.data) {
      const { currentPage, totalPages, totalRecords, records } = tripsSuccess.data

      setTripsTotalPages(totalPages)
      setTripsTotalRecords(totalRecords)
      setTripsPage(currentPage)
      setTripsData(records)
    }
  }, [tripsSuccess])

  const handleGetTrips = useCallback(
    (page: number = 1, size: number = pageSize, onSuccess?: () => void) => {
      const payload: GetAllTripsForAdminRequestPayload = {
        request: {
          page,
          size,
          searchQuery
        },
        onSuccess
      }

      dispatch(getAllTripsForAdmin(payload))
    },
    [dispatch, searchQuery, pageSize]
  )

  const handleGetTripDetailsForAdmin = useCallback(
    (page: number = 1, size: number = pageSize, tripId: string, userId: string) => {
      const tripDetailsPayload: GetTripDetailsForAdminRequestPayload = {
        request: { flightItineraryId: tripId, page, size }
      }

      const tripOfferRequestsPayload: GetTripOfferRequestsForAdminRequestPayload = {
        request: { flightItineraryId: tripId, page, size }
      }

      const tripPaymentDetailsPayload: GetTripPaymentDetailsForAdminRequestPayload = {
        request: { flightItineraryId: tripId }
      }

      demoRouter.navigate(`/${adminNavigationPaths.trips}/${userId}/Trips/${tripId}`)
      dispatch(getTripDetailsForAdmin(tripDetailsPayload))
      dispatch(getTripOfferRequestsForAdmin(tripOfferRequestsPayload))
      dispatch(getTripPaymentDetailsForAdmin(tripPaymentDetailsPayload))
    },
    [dispatch, demoRouter, pageSize]
  )

  useEffect(() => {
    handleGetTrips()
  }, [handleGetTrips])

  return (
    <Box sx={styles.container}>
      <Table
        columns={tripTableColumns}
        data={tripsData}
        onRowClick={(_, index) => {
          const tripId = tripsData[index].flightItineraryDetails.id
          const user = tripsData[index].flightItineraryDetails.traveler
          const userId = user.id.toString()

          setSelectedUser(user)

          if (tripId) {
            handleGetTripDetailsForAdmin(1, pageSize, tripId, userId.toString())
          }
        }}
        pagination={{
          currentPage: tripsPage,
          totalPages: tripsTotalPages,
          totalRecords: tripsTotalRecords,
          onNext: () => handleGetTrips(tripsPage + 1),
          onPrevious: () => handleGetTrips(tripsPage - 1)
        }}
        initialLoading={tripsLoading}
        error={!!tripsError}
        onRetry={() => handleGetTrips()}
        inPage
      />
    </Box>
  )
}

export default Trips
